const DateInputField = ({
  label,
  name,
  value,
  compulsory = false,
  noGaps = false,
  error,
  ...props
}) => (
  <div className={`form-group ${noGaps ? `mt-0` : `mt-3`}`}>
    <label className="label">{label}</label>
    <div className="flex">
      <input
        type="date"
        className="input"
        name={name}
        value={value || ""}
        {...props}
      />
      {compulsory && <span className="label-imp">*</span>}
    </div>
    {error && !noGaps && <p className="label-error">{error}</p>}
  </div>
);

export default DateInputField;
